import React, { useEffect, useState } from 'react';
import Popup from '../RegisterScreen/Popup';
import MyProfilesidebar from '../Myprofile/MyProfilesidebar';
import axios from 'axios';
import { api } from '../../Constant';
import { useNavigate } from 'react-router-dom';

const Coupouns = () => {
    const [popupVisible, setPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupType, setPopupType] = useState('success');
    const navigate = useNavigate();
    const [coupnlist, setCoupnlist] = useState([]);
    const [couponErrorMessage, setCouponErrorMessage] = useState(null);

    useEffect(() => {
        const totalamnt = localStorage.getItem("totalamnt");
        const userId = localStorage.getItem("userId");
        axios
            .post(api + "Coupon_list", {
                user_id: userId,
                total_amount: totalamnt
            })
            .then((response) => {
                if (response.data.success === "true") {
                    setCoupnlist(response.data.coupons);
                } else {
                    setCouponErrorMessage("No Coupouns Available"); // Set error message from response
                }
            })
            .catch((error) => {
                console.log("Error:", error);
                setCouponErrorMessage("No Coupouns Available"); // Generic error message
            });
    }, []);
    // Handle popup close
    const handleClosePopup = () => {
        setPopupVisible(false);
    };
    const couponid = (couponid) => {
        localStorage.setItem('coupon_id', couponid);
        navigate('/shoping-cart');
    }
    return (
        <div className="myprofile-bg pt-40 pb-40">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <MyProfilesidebar />
                    </div>
                    <div className="col-lg-9">
                        <div className="myprofile-overview">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="add-address-tittle">
                                        <h5 style={{ color: '#000' }}>Coupons</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="row billing-form">
                                <div className="col-lg-12">
                                    {/* Show coupon error message */}
                                    {couponErrorMessage ? (
                                        <div className="error-message" style={{ color: 'red', marginBottom: '20px' }}>
                                            <p>{couponErrorMessage}</p>
                                        </div>
                                    ) : (
                                        // Render coupon list if no error
                                        coupnlist.map((item) => {
                                            return (
                                                <div key={item.coupon_id} className='coupoun-main'>
                                                    <div className='coupon-title'>
                                                        <h4>Extra
                                                            {item.coupon_type === "Amount" ? (
                                                                <> ₹{item.amount} </>
                                                            ) : (
                                                                <> {item.percentage} % </>
                                                            )}
                                                            off on {item.coupon_name}
                                                        </h4>
                                                        <div className='code-num'>
                                                            <h6>{item.coupon_code}</h6>
                                                        </div>
                                                    </div>
                                                    <div className='apply-btn'>
                                                        <button onClick={() => couponid(item.coupon_id)}>Apply</button>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>
                            {popupVisible && (
                                <Popup
                                    message={popupMessage}
                                    title="Notice"
                                    type={popupType}
                                    onClose={handleClosePopup}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Coupouns;